import { RootState } from "@/vuex/types";
import { Module } from "vuex";
import { actions } from "./room.actions";
import { getters } from "./room.getters";
import { mutations } from "./room.mutations";
import { state } from "./room.state";
import { RoomState } from "./room.types";

const namespaced: boolean = true;
export const RoomModule: Module<RoomState, RootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations
};
